// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae29f853","239":"bf458bc1","455":"40a649c0"}[chunkId] + ".chunk.js";
};